import './css/main.css'
import { Link, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquareXmark, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { checkLogin } from '../store';
import { SyncLoader } from "react-spinners";
import Message from './common/message';
import { changeNum } from './common/function';

import moment from 'moment';
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import './css/calendar.css'

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

let jackpotEstA = 0;

function JackpotSetting() {
    const [budgetData, setBudgetData] = useState([])
    const [data, setData] = useState([]);
    const today = new Date();
    const [date, setDate] = useState(today);
    const [activeStartDate, setActiveStartDate] = useState(new Date());
    const [rows, setRows] = useState([]); // 수정 가능한 데이터
    const [originalRows, setOriginalRows] = useState([]); // 원본 데이터
    const [changeValue, setChangeValue] = useState(false);
    const [spinner, setSpinner] = useState(false);
    const [reload, setReload] = useState(false)
    const [btn, setBtn] = useState(0)

    const [userJackpostData, setUserJackpotData] = useState([])
    const [jackpotImg, setJackpotImg] = useState([])
    const [dianModal, setDiaModal] = useState(false)
    const [budgetnModal, setBudgetModal] = useState(false)
    const [clickId, setClickId] = useState([])

    // 2025-01-24 정빈 추가
    const [budgetAmount, setBudgetAmount] = useState(0);
    const [userCount, setUserCount] = useState(0);

    let dark = useSelector((state) => { return state.Darkmode.value });
    const darkname = dark ? 'dark' : "";

    let dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const objString = localStorage.getItem('token');
        if (objString != null) {
            const obj = JSON.parse(objString);
            if (Date.now() > obj.expire) {
                localStorage.removeItem('token');
                dispatch(checkLogin(false));
                navigate('/')
            }
            else {
                dispatch(checkLogin(true));
            }
        }
        else {
            dispatch(checkLogin(false));
            navigate('/')
        }
    }, [])

    useEffect(() => {
        BudgetData()
        UpgradeData();
        UserJackportData()
        JackportImgData()
    }, [reload]);

    const BudgetData = async () => {
        await axios.get(process.env.REACT_APP_API + '/api/budget', {
            // headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                setBudgetData(tmp?.data?.budget ?? [])
            }
        }).catch((error) => {
            console.log(error)
        })
    };

    const UpgradeData = async () => {
        setSpinner(true);
        await axios.get(process.env.REACT_APP_API + '/api/jackpot/time')
            .then((response) => {
                let tmp = response.data;
                if (tmp?.code == 1000) {
                    setData(tmp?.data?.jackpot ?? []);
                    setSpinner(false);
                } else {
                    setSpinner(false);
                }
            }).catch((error) => {
                console.log(error);
            });
    };

    const UserJackportData = async () => {
        await axios.get(process.env.REACT_APP_API + '/api/jackpot/setting')
            .then((response) => {
                let tmp = response.data;
                if (tmp?.code == 1000) {
                    setUserJackpotData(tmp?.data?.setting ?? []);
                    setBudgetAmount(tmp?.data?.normalAmount ?? 0)
                    setUserCount(tmp?.data?.totalUser ?? 0)
                }
            }).catch((error) => {
                console.log(error);
            });
    };

    const JackportImgData = async () => {
        await axios.get(process.env.REACT_APP_API + '/api/setting/jackpot/img')
            .then((response) => {
                let tmp = response.data;
                if (tmp?.code == 1000) {
                    setJackpotImg(tmp?.data?.jackpot ?? []);
                }
            }).catch((error) => {
                console.log(error);
            });
    };

    const handleDateChange = (newDate) => {
        setDate(newDate);
    };

    const handleTodayClick = () => {
        const today = new Date();
        setActiveStartDate(today);
        setDate(today);
    };

    useEffect(() => {
        if (data) {
            let RateTime = [];
            // data.forEach((a) => {
            //     if (moment(date).format('YYYY-MM-DD') === a.jackpot_date && a?.jackpot_rate && a?.jackpot_timezone) {
            //         const timezones = a.jackpot_timezone.split("/");
            //         const rates = a.jackpot_rate.split("/");
            //         timezones.forEach((timezone, index) => {
            //             const start = `${timezone.slice(0, 2)}:${timezone.slice(2, 4)}`;
            //             const end = `${timezone.slice(4, 6)}:${timezone.slice(6, 8)}`;
            //             RateTime.push({ start, end, rate: rates[index] });
            //         });
            //     }
            // });

            // // `start` 시간을 기준으로 정렬
            // RateTime.sort((a, b) => {
            //     const timeA = moment(a.start, "HH:mm");
            //     const timeB = moment(b.start, "HH:mm");
            //     return timeA - timeB;
            // });

            data.forEach((a) => {
                const start = `${a.startTime.slice(0, 5)}`; // HH:MM 형식
                const end = `${a.endTime.slice(0, 5)}`;   // HH:MM 형식

                RateTime.push({ start, end, rate: Number(a.ratio) }); // 초 단위 제외하고 저장
            });

            setRows(RateTime); // 수정용 데이터 초기화
            setOriginalRows(RateTime); // 원본 데이터 저장
        }
    }, [data, date]);


    // 추가 버튼
    const handleAddRow = () => {
        setRows([...rows, { start: "", end: "", rate: "" }]);
    };

    // 수정 버튼
    const handleEdit = () => {
        setChangeValue(true);
    };

    // 저장 버튼
    const handleSave = async () => {
        // 유효하지 않은 행 필터링
        const validRows = rows.filter(row => row.start && row.end && row.rate);

        if (validRows.length === 0) {
            alert("저장할 유효한 데이터가 없습니다.");
            return;
        }

        // 겹치는 시간 범위 확인
        const hasOverlap = validRows.some((row, index) => {
            const startA = moment(row.start, "HH:mm");
            const endA = moment(row.end, "HH:mm");
            return validRows.some((otherRow, otherIndex) => {
                if (index === otherIndex) return false; // 자기 자신은 제외
                const startB = moment(otherRow.start, "HH:mm");
                const endB = moment(otherRow.end, "HH:mm");
                // 시간 범위가 겹치는지 확인
                return startA.isBefore(endB) && endA.isAfter(startB);
            });
        });

        if (hasOverlap) {
            alert("시간 범위가 겹치는 항목이 있습니다. 수정 후 다시 시도하세요.");
            return;
        }

        const slots = validRows.map(row => ({
            start_time: row.start,
            end_time: row.end,
            ratio: Number(row.rate || 0), // rate를 숫자로 변환하여 저장
        }));

        // API 요청
        await axios.post(process.env.REACT_APP_API + '/api/jackpot/time', {
            slots: slots
        }).then((response) => {
            let tmp = response.data;
            if (tmp?.code === 1000) {
                console.log("저장 성공");
                setReload(e => !e);
            }
            setChangeValue(false);
        }).catch((error) => {
            console.log(error);
        });
    };


    // 취소 버튼
    const handleCancel = () => {
        setRows(originalRows); // 원본 데이터로 복원
        setChangeValue(false); // 수정 모드 종료
    };

    // 삭제 버튼
    const handleDeleteRow = (index) => {
        setRows((prevRows) => prevRows.filter((_, i) => i !== index));
    };

    const handleInputChange = (index, field, value) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = value;
        setRows(updatedRows);
    };

    const [formData, setFormData] = useState({
        rate: "", // 리디렉션 URL
        file: '', // 업로드된 파일
    });

    const [imagePreviews, setImagePreviews] = useState([]);

    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;

        if (type === 'checkbox') {
            setFormData({ ...formData, [name]: checked });
        } else if (type === 'file') {
            setFormData({ ...formData, file: files });
            handleImagePreview(files);
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    // 이미지 미리보기 처리 함수
    const handleImagePreview = (files) => {
        const previewArray = Array.from(files).map((file) => {
            const reader = new FileReader();
            return new Promise((resolve) => {
                reader.onloadend = () => {
                    resolve(reader.result); // 파일의 base64 데이터를 resolve
                };
                reader.readAsDataURL(file); // 파일을 base64로 변환
            });
        });

        Promise.all(previewArray).then((images) => {
            setImagePreviews(images); // 미리보기 이미지들을 저장
        });
    };

    const onSubmit = async () => {
        const formDataObj = new FormData();

        formDataObj.append('rate', formData.rate);
        if (formData.file.length > 0) {
            formDataObj.append("file", formData.file[0]);
        } else {
            alert("이미지를 선택하세요.");
            return;
        }

        await axios.post(process.env.REACT_APP_API + "/api/setting/jackpot/img-regist", formDataObj, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                setFormData({
                    rate: "", // 리디렉션 URL
                    file: '', // 업로드된 파일
                })
                setImagePreviews([])
                setReload(e => !e)
            }
            else {
                // setMessage({ msg: "등록에 실패했습니다." })
            }
        }).catch(error => {
            console.error(error);
        });
    }


    const [inputValues, setInputValues] = useState([]);

    useEffect(() => {
        if (userJackpostData?.length) {
            setInputValues(userJackpostData.map((item) => ({ id: item.id, value: item.value })));
        }
    }, [userJackpostData]);

    const handleJackpotInputChange = (id, value) => {
        setInputValues((prev) =>
            prev.map((item) => (item.id === id ? { ...item, value } : item))
        );
    };

    const onSubmitUpdate = async () => {
        await axios.post(process.env.REACT_APP_API + '/api/jackpot/setting/update', {
            settings: inputValues
        }, {
            // headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                setReload(e => !e)
            }
        }).catch((error) => {
            console.log(error)
        })
    };
    
    return (
        <div className='main'>
            {dianModal && (<DiaModal dark={dark} darkname={darkname} setDiaModal={setDiaModal} clickId={clickId} setReload={setReload} />)}
            {budgetnModal && (<BudgetUpdate darkname={darkname} setBudgetModal={setBudgetModal} clickId={clickId} setReload={setReload} />)}

            <div className='maintab' style={{ marginBottom: "20px" }}>
                <div className={btn === 0 ? `maintab-1 on ${darkname}` : `maintab-1 ${darkname}`} onClick={() => { setBtn(0) }}>버짓설정</div>
                <div className={btn === 2 ? `maintab-1 on ${darkname}` : `maintab-1 ${darkname}`} onClick={() => { setBtn(2) }}>잭팟설정</div>
                <div className={btn === 1 ? `maintab-1 on ${darkname}` : `maintab-1 ${darkname}`} onClick={() => { setBtn(1) }}>잭팟이미지</div>
            </div>
            <div className={`main-box-1 ${darkname}`}>
                {
                    btn === 0
                        ?
                        <>
                            <div>
                                <div className={`StyledCalendarWrapper ${darkname}`} style={{ width: "1000px" }}>
                                    <Calendar
                                        value={date}
                                        onChange={handleDateChange}
                                        formatDay={(locale, date) => moment(date).format('D')}
                                        formatYear={(locale, date) => moment(date).format('YYYY')}
                                        formatMonthYear={(locale, date) => moment(date).format('YYYY. MM')}
                                        calendarType="gregory"
                                        showNeighboringMonth={false}
                                        next2Label={null}
                                        prev2Label={null}
                                        minDetail="year"
                                        activeStartDate={activeStartDate === null ? undefined : activeStartDate}
                                        onActiveStartDateChange={({ activeStartDate }) =>
                                            setActiveStartDate(activeStartDate)
                                        }
                                        tileDisabled={({ date, view }) => {
                                            if (view === "month") {
                                                // 오늘 이전 날짜는 비활성화
                                                return moment(date).isBefore(moment(), 'day');
                                            }
                                            return false;
                                        }}
                                        tileContent={({ date, view }) => {
                                            if (view === "month") {
                                                const tmp = budgetData.find(
                                                    (item) => item.budget_date === moment(date).format("YYYY-MM-DD")
                                                );

                                                if (tmp) {
                                                    return (
                                                        <div
                                                            key={`${tmp.budget_date}`} // 고유한 key 값 생성
                                                            className={`StyledEX ${moment(date).isBefore(moment(), 'day') ? 'disabled' : ''}`}
                                                            style={{
                                                                pointerEvents: moment(date).isBefore(moment(), 'day') ? "none" : "auto",
                                                                opacity: moment(date).isBefore(moment(), 'day') ? 0.5 : 1,
                                                            }}
                                                            onClick={() => {
                                                                if (!moment(date).isBefore(moment(), 'day')) {
                                                                    setClickId(tmp);
                                                                    setBudgetModal(true);
                                                                }
                                                            }}
                                                        >
                                                            <div className="StyledEX-1">
                                                                <div>전체:</div>
                                                                <div>{changeNum(tmp.total_budget)}</div>
                                                            </div>
                                                            <div className="StyledEX-2">
                                                                <div>잭팟:</div>
                                                                <div>
                                                                    {changeNum(tmp.spent_amount)} / {changeNum(tmp.awarded_count)}건
                                                                </div>
                                                            </div>
                                                            <div className="StyledEX-3">
                                                                <div>잔액:</div>
                                                                <div>{changeNum(tmp.remaining_amount)}</div>
                                                            </div>
                                                        </div>
                                                    );
                                                }
                                            }
                                            return null;
                                        }}
                                    />

                                    <div className='StyledDate' onClick={handleTodayClick}>Today</div>
                                </div>
                            </div>
                            <div className={`member-2 ${darkname}`} style={{ width: "400px" }}>
                                <div className='gameSetting-btn-1' style={{ marginBottom: "20px" }}>
                                    {changeValue ? (
                                        <>
                                            <div className='gameSetting-btn-2' onClick={handleCancel}>취소</div>
                                            <div className='gameSetting-btn-2' onClick={handleAddRow}>추가</div>
                                            <div className='gameSetting-btn-2' onClick={handleSave}>저장</div>
                                        </>
                                    ) : (
                                        <div className='gameSetting-btn-2' onClick={handleEdit}>수정</div>
                                    )}
                                </div>
                                <div className='gameSetting-btn-1' style={{ marginBottom: "10px" }}>
                                    <div className='gameSetting-btn-text' style={{ width: "310px", display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                        <div>* 총 비율:</div>
                                        {/* <div>{Math.max(...rows.map(row => Number(row.rate || 0)))??100}%</div> */}
                                        <div>100%</div>
                                    </div>
                                </div>

                                <div className={`table-head ${darkname}`}>
                                    <div>시작시간</div>
                                    <div>종료시간</div>
                                    <div>비율</div>
                                    <div style={{ width: "10%", minWidth: "50px" }}></div>
                                </div>
                                <div className='table-body' style={{ minHeight: "600px" }}>
                                    {spinner ? (
                                        <div className='spinner-modal'>
                                            <SyncLoader color="#003577" />
                                        </div>
                                    ) : rows.length === 0 ? (
                                        <div className='data-nofound'>
                                            <img src='/img/img_nofound.png' alt="No records found" />
                                            <p>NO RECORDS FOUND</p>
                                        </div>
                                    ) : (
                                        rows.map((row, index) => (
                                            <div key={index} className={`table-body-tr ${darkname}`}>
                                                <div className='td'>
                                                    {changeValue ? (
                                                        <input
                                                            type="text"
                                                            value={row.start}
                                                            onChange={(e) => handleInputChange(index, "start", e.target.value)}
                                                        />
                                                    ) : (
                                                        row.start
                                                    )}
                                                </div>
                                                <div className='td'>
                                                    {changeValue ? (
                                                        <input
                                                            type="text"
                                                            value={row.end}
                                                            onChange={(e) => handleInputChange(index, "end", e.target.value)}
                                                        />
                                                    ) : (
                                                        row.end
                                                    )}
                                                </div>
                                                <div className='td'>
                                                    {changeValue ? (
                                                        <input
                                                            type="text"
                                                            value={row.rate}
                                                            onChange={(e) => handleInputChange(index, "rate", e.target.value)}
                                                        />
                                                    ) : (
                                                        row.rate
                                                    )}
                                                </div>
                                                <div className='td' style={{ width: "10%", minWidth: "50px" }}>
                                                    {changeValue && (
                                                        <FontAwesomeIcon icon={faSquareXmark} onClick={() => handleDeleteRow(index)} style={{ fontSize: "22px", color: 'gray', cursor: 'pointer' }} />
                                                    )}
                                                </div>
                                            </div>
                                        ))
                                    )}
                                </div>
                            </div>
                        </>
                        :
                        btn === 1
                            ?
                            <div style={{ width: "100%" }}>
                                <div className='budget-box' style={{ marginBottom: "20px" }}>
                                    <div style={{ marginBottom: "20px", fontSize: "18px", fontWeight: "bold" }}>이미지 등록</div>
                                    <div className='create-img-box'>
                                        <div className=''>
                                            <div className='budget-2'>
                                                <div className='budget-1-3'>이미지 첨부</div>
                                                <div className='budget-1-2'>
                                                    <label htmlFor="file" className="form-control file_form" style={{ display: "block" }}>
                                                        {formData.file ? Array.from(formData.file).map(file => file.name).join(', ') : "파일선택"}
                                                    </label>
                                                    <input type="file" id="file" name="file" style={{ display: "none" }} multiple accept="image/*" onChange={handleChange} />
                                                </div>
                                            </div>
                                            <div className='budget-2'>
                                                <div className='budget-1-3'>잭팟 최소 금액</div>
                                                <div className='budget-1-2'>
                                                    <input className='file-input' style={{ width: "300px" }} type="text" name="rate" placeholder="최소 금액" value={formData.rate || ""} onChange={handleChange} />
                                                </div>
                                            </div>
                                            <div className='ads-btn' onClick={() => onSubmit()}>등록</div>
                                        </div>
                                        <div className='ads-preImg'>
                                            <div>미리보기</div>
                                            {
                                                imagePreviews.length > 0 &&
                                                imagePreviews.map((src, index) => (
                                                    <img key={index} src={src} alt={`preview ${index}`} className="multipreview" style={{ height: "200px" }} />
                                                ))
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className={`main-box ${darkname}`}>
                                    <div style={{ textAlign: "left", paddingLeft: "20px", lineHeight: "24px" }}>
                                        <FontAwesomeIcon icon={faArrowRight} /> 잭팟 이미지는 설정된 잭팟 다이아가 속한 구간의 이미지가 노출 됩니다.<br />
                                        <FontAwesomeIcon icon={faArrowRight} /> 첫번째 구간(0~)은 최소 금액을 수정할 수 없고, 이미지만 수정 가능하니다.<br />

                                        {/* 구간 이미지를 등록하지 않거나, 구간이 없을 경우 기본 이미지(보라괴물)가 노출 됩니다.<br />
                                        Ex) 하늘괴물이 200, 초록괴물이 400 으로 등록되어 있을 때,<br />
                                        <span style={{ paddingLeft: "25px" }}>잭팟 다이아 500 <FontAwesomeIcon icon={faArrowRight} /> 초록괴물 노출</span><br />
                                        <span style={{ paddingLeft: "25px" }}>잭팟 다이아 300 <FontAwesomeIcon icon={faArrowRight} /> 하늘괴물 노출</span><br />
                                        <span style={{ paddingLeft: "25px" }}>잭팟 다이아 100 <FontAwesomeIcon icon={faArrowRight} /> 보라괴물 노출</span><br /> */}
                                    </div>
                                    <div className={`member-2 ${darkname}`} style={{ marginTop: "50px", width: "1000px" }}>
                                        <div className={`table-head ${darkname}`}>
                                            <div style={{ width: "15%", minWidth: "150px" }}>잭팟 다이아 구간</div>
                                            <div style={{ width: "50%", minWidth: "200px" }}>이미지 미리보기</div>
                                            <div style={{ width: "10%", minWidth: "200px" }}>가로(추천: 200px)</div>
                                            <div style={{ width: "10%", minWidth: "200px" }}>세로</div>
                                            <div style={{ width: "15%", minWidth: "150px" }}></div>
                                        </div>
                                        <div className='table-body' style={{ minHeight: "600px" }}>
                                            {
                                                spinner
                                                    ?
                                                    <div className='spinner-modal'>
                                                        <SyncLoader color="#003577" />
                                                    </div>
                                                    :
                                                    jackpotImg.length === 0
                                                        ?
                                                        <div className='data-nofound'>
                                                            <img src='/img/img_nofound.png'></img>
                                                            <img src='/img/img_nofound_dark.svg' style={{ display: "none" }}></img>
                                                            <p>NO RECORDS FOUND</p>
                                                        </div>
                                                        :
                                                        <>
                                                            {
                                                                jackpotImg.map(function (a, i) {
                                                                    const nextValue = i < jackpotImg.length - 1 ? jackpotImg[i + 1] : null;
                                                                    return (
                                                                        <JackpotImgList key={i} item={a} darkname={darkname} dark={dark} setReload={setReload} newBudget={nextValue} />
                                                                    )
                                                                })
                                                            }
                                                        </>

                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className={`member-2 ${darkname}`} style={{ width: "800px" }}>
                                <div className={`table-head ${darkname}`}>
                                    <div style={{ width: "1%", minWidth: "50px" }}>no.</div>
                                    <div style={{ width: "15%", minWidth: "150px" }}>밸류</div>
                                    <div style={{ width: "20%", minWidth: "250px" }}>형식</div>
                                    <div style={{ width: "49%", minWidth: "350px" }}>설명</div>
                                </div>
                                <div className="table-body" style={{ minHeight: "260px" }}>
                                    {spinner ? (
                                        <div className="spinner-modal">
                                            <SyncLoader color="#003577" />
                                        </div>
                                    ) : userJackpostData.length === 0 ? (
                                        <div className="data-nofound">
                                            <img src="/img/img_nofound.png" alt="No data found" />
                                            <p>NO RECORDS FOUND</p>
                                        </div>
                                    ) : (
                                        <>
                                            {userJackpostData.map((a, i) => (
                                                <MemberItem
                                                    key={i}
                                                    item={a}
                                                    seq={i + 1}
                                                    darkname={darkname}
                                                    dark={dark}
                                                    handleJackpotInputChange={handleJackpotInputChange}
                                                    budgetAmount={budgetAmount}
                                                    userCount={userCount}
                                                />
                                            ))}
                                        </>
                                    )}
                                </div>
                                <div className="gameSetting-btn-1">
                                    <div className="gameSetting-btn-2" onClick={() => onSubmitUpdate()}>저장</div>
                                </div>
                            </div>
                }
            </div >
        </div >
    );
}

function MemberItem({ item, seq, darkname, dark, handleJackpotInputChange, budgetAmount, userCount }) {
    const [inputValue, setInputValue] = useState(item.value); // 초기값 설정

    useEffect(() => {
        setInputValue(item.value)
    }, [item])

    if (item.name === "jackpot_default_ratio") {
        jackpotEstA = item.value;
    }

    const onChangeInputValue = (e) => {
        const { value } = e.target;
        const onlyNumber = value
            .replace(/[^0-9.]/g, "")
            .replace(/(\..*?)\./g, "$1")
            .replace(/^\./, "");
        setInputValue(onlyNumber);
        handleJackpotInputChange(item.id, onlyNumber); // 상위 컴포넌트로 값 전달
    };

    return (
        <div className={`table-body-tr ${darkname}`}>
            <div className="td" style={{ width: "1%", minWidth: "50px" }}>{seq}</div>
            <div className="td" style={{ width: "15%", minWidth: "150px" }}>
                <input
                    value={inputValue}
                    onChange={onChangeInputValue}
                    placeholder={item.value}
                    style={{ width: "95%", minWidth: "140px", padding: "3px" }}
                />
            </div>
            <div className="left td" style={{ width: "20%", minWidth: "250px" }}>
                {item.format}
                &emsp;&emsp;&emsp;<div style={{ color: "red" }}>
                    {item.name === "jackpot_default_ratio" ? "잭팟 평균: " + changeNum(budgetAmount / userCount * jackpotEstA).split('.')[0] : ""}
                    {item.name === "jackpot_up_ratio" ? "잭팟 최대: " + changeNum(budgetAmount / userCount * jackpotEstA * item.value).split('.')[0] : ""}
                    {item.name === "jackpot_down_ratio" ? "잭팟 최소: " + changeNum(budgetAmount / userCount * jackpotEstA * item.value).split('.')[0] : ""}
                </div>
            </div>
            <div className="left td" style={{ width: "49%", minWidth: "350px" }}>{item.desc}</div>
        </div>
    );
}

function DiaModal({ dark, darkname, setDiaModal, clickId, setReload }) {
    const [userDayData, setUserDayData] = useState([]);
    const [originalData, setOriginalData] = useState([]); // 원본 데이터를 저장
    const [isEditing, setIsEditing] = useState(false); // 수정 모드 여부

    useEffect(() => {
        UpgradeData();
    }, []);

    const UpgradeData = async () => {
        await axios
            .get(process.env.REACT_APP_API + "/api/jackpot/user", {
                params: {
                    userId: clickId.user_id,
                    bdgId: clickId.bdg_id,
                },
            })
            .then((response) => {
                let tmp = response.data;
                if (tmp?.code == 1000) {
                    const parsedData = tmp?.data?.jackpot.map(item => {
                        const { start, end } = parseTimezone(item.timezone);
                        return { ...item, start, end };
                    }) ?? [];
                    setUserDayData(parsedData);
                    setOriginalData(parsedData); // 원본 데이터 저장
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleInputChange = (index, field, value) => {
        const updatedData = [...userDayData];
        updatedData[index][field] = value;
        setUserDayData(updatedData);
    };

    const onSubmitUpdateGold = async () => {
        const formattedData = userDayData.map((item) => ({
            jackpotId: item.id,
            timezone: item.start.padEnd(4, '0') + item.end.padEnd(4, '0'),
            gold: item.gold,
            state: item.state,
        }));

        await axios.post(process.env.REACT_APP_API + "/api/jackpot/user-update", {
            jackpot: formattedData
        })
            .then((response) => {
                let tmp = response.data;
                if (tmp?.code == 1000) {
                    setDiaModal(false);
                    setReload((e) => !e);
                    setIsEditing(false);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleCancel = () => {
        setUserDayData(originalData); // 원본 데이터 보관
        setIsEditing(false); // 수정 모드 종료
    };

    const parseTimezone = (timezone) => {
        if (timezone.length === 4) {
            return {
                start: timezone.substring(0, 2) + "00",
                end: timezone.substring(2, 4) + "00",
            };
        } else if (timezone.length === 8) {
            return {
                start: timezone.substring(0, 4),
                end: timezone.substring(4, 8),
            };
        } else {
            return {
                start: "0000",
                end: "0000"
            };
        }
    };

    return (
        <div className="modal">
            <div className="modal-box">
                <div className="modal-1" style={{ width: "660px" }}>
                    <div className="modal-1-header">유저 아이디: {clickId.user_id}</div>

                    <div className={`member-2 ${darkname}`} style={{ width: "600px" }}>
                        <div className={`table-head ${darkname}`}>
                            <div style={{ width: "20%", minWidth: "50px" }}>버짓 아이디</div>
                            <div style={{ width: "20%", minWidth: "50px" }}>시작시간</div>
                            <div style={{ width: "20%", minWidth: "50px" }}>종료시간</div>
                            <div style={{ width: "20%", minWidth: "50px" }}>버짓 금액</div>
                            <div style={{ width: "20%", minWidth: "50px" }}>당첨 상태</div>
                        </div>
                        <div className="table-body" style={{ minHeight: "600px" }}>
                            {userDayData.length === 0 ? (
                                <div className="data-nofound">
                                    <img src="/img/img_nofound.png" alt="No records found" />
                                    <p>NO RECORDS FOUND</p>
                                </div>
                            ) : (
                                <>
                                    {userDayData.map((item, i) => (
                                        <div className={`table-body-tr ${darkname}`} key={i}>
                                            <div className="left td" style={{ width: "20%", minWidth: "50px" }}>
                                                {item.id}
                                            </div>
                                            <div className="right td" style={{ width: "20%", minWidth: "50px" }}>
                                                {isEditing ? (
                                                    <input
                                                        type="text"
                                                        value={item.start}
                                                        onChange={(e) =>
                                                            handleInputChange(
                                                                i,
                                                                "start",
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                ) : (
                                                    `${item.start.substring(0, 2)}:${item.start.substring(2, 4)}`
                                                )}
                                            </div>
                                            <div className="right td" style={{ width: "20%", minWidth: "50px" }}>
                                                {isEditing ? (
                                                    <input
                                                        type="text"
                                                        value={item.end}
                                                        onChange={(e) =>
                                                            handleInputChange(
                                                                i,
                                                                "end",
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                ) : (
                                                    `${item.end.substring(0, 2)}:${item.end.substring(2, 4)}`
                                                )}
                                            </div>
                                            <div className="right td" style={{ width: "20%", minWidth: "50px" }}>
                                                {isEditing ? (
                                                    <input
                                                        type="number"
                                                        value={item.gold}
                                                        onChange={(e) => handleInputChange(i, "gold", e.target.value)}
                                                    />
                                                ) : (
                                                    item.gold
                                                )}
                                            </div>
                                            <div className="right td" style={{ width: "20%", minWidth: "50px" }}>
                                                {isEditing ? (
                                                    <select
                                                        value={item.state}
                                                        onChange={(e) => handleInputChange(i, "state", e.target.value)}
                                                    >
                                                        <option value="Y">Y</option>
                                                        <option value="N">N</option>
                                                    </select>
                                                ) : (
                                                    item.state
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </>
                            )}
                        </div>
                    </div>

                    <div className="modal-btn-box">
                        {isEditing ? (
                            <>
                                <div className={`modal-btn ${darkname}`} onClick={handleCancel}>
                                    취소
                                </div>
                                <div className={`modal-btn ${darkname}`} onClick={onSubmitUpdateGold}>
                                    등록
                                </div>
                            </>
                        ) : (
                            <>
                                <div className={`modal-btn ${darkname}`} onClick={() => setDiaModal(false)}>
                                    취소
                                </div>
                                <div className={`modal-btn ${darkname}`} onClick={() => setIsEditing(true)}>
                                    수정
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

function BudgetUpdate({ darkname, setBudgetModal, clickId, setReload }) {
    const [input, setInput] = useState("")
    const onChangeInput = (e) => {
        const { value } = e.target
        const onlyNumber = value.replace(/[^0-9]/g, "")
        setInput(onlyNumber)
    }

    const onSubmitUpdateGold = async () => {
        await axios.post(process.env.REACT_APP_API + '/api/budget', {
            budgetId: clickId.id,
            budgetAmount: input
        }, {
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                setBudgetModal(false)
                setReload(e => !e)
            }
        }).catch((error) => {
            console.log(error)
        })
    };

    return (
        <div className='modal'>
            <div className='modal-box'>
                <div className='modal-1' style={{ width: "400px" }}>
                    <div className='modal-1-header'>버짓 수정</div>

                    <div style={{ marginBottom: "30px" }}>
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className='password'>기존 버짓</div>
                            <div className={`password-1 ${darkname}`}>
                                <div>{changeNum(clickId.total_budget)}</div>
                            </div>
                        </div>
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className='password'>사용된 버짓</div>
                            <div className={`password-1 ${darkname}`}>
                                <div>{changeNum(clickId.spent_amount)}</div>
                            </div>
                        </div>
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className='password'>버짓 총량 변경</div>
                            <div className={`password-1 ${darkname}`}>
                                <input value={input} onChange={onChangeInput} placeholder='버짓 총량 변경' />
                            </div>
                        </div>
                    </div>
                    <div className='modal-btn-box'>
                        <div className={`modal-btn ${darkname}`} onClick={() => { onSubmitUpdateGold() }}>확인</div>
                        <div className={`modal-btn ${darkname}`} onClick={() => setBudgetModal(false)}>취소</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

function JackpotImgList({ item, darkname, dark, setReload, setMessage, newBudget }) {
    const [jackpotImgModal, setJackpotImgModal] = useState(false);
    const [clickId, setClickId] = useState([]);
    const [dimensions, setDimensions] = useState({ width: 0, height: 50 }); // 이미지 크기 상태

    const onClickData = () => {
        setClickId(item);
        setJackpotImgModal(true);
    };

    const onSubmitDelete = async () => {
        await axios
            .post(
                process.env.REACT_APP_API + "/api/setting/jackpot/img-delete",
                { imgId: item.id },
                {
                    // headers: { 'Content-Type': 'multipart/form-data' },
                }
            )
            .then((response) => {
                let tmp = response?.data;
                if (tmp?.code < 2000) {
                    setReload((e) => !e);
                } else {
                    // setMessage({ msg: "등록에 실패했습니다." })
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const handleImageLoad = (e) => {
        const img = e.target;
        setDimensions({
            width: img.naturalWidth, // 원본 가로 크기
            height: img.naturalHeight, // 원본 세로 크기
        });
    };

    return (
        <>
            <div className={`table-body-tr ${darkname}`} style={{ height: dimensions.height }}>
                {jackpotImgModal && (
                    <JackpotImgModal
                        darkname={darkname}
                        setJackpotImgModal={setJackpotImgModal}
                        clickId={clickId}
                        setReload={setReload}
                    />
                )}
                <div className="td" style={{ width: "15%", minWidth: "150px", fontSize: "14px" }}>
                    {item?.gold_rate ?? ""}~{newBudget?.gold_rate ? newBudget?.gold_rate - 1 : ""}
                </div>
                <div className="td" style={{ width: "50%", minWidth: "200px" }}>
                    <img
                        src={item.url}
                        alt="Jackpot"
                        onLoad={handleImageLoad} // 이미지 로드 이벤트 핸들러
                    />
                </div>
                <div className="td" style={{ width: "10%", minWidth: "200px" }}>{dimensions.width}px</div>
                <div className="td" style={{ width: "10%", minWidth: "200px" }}>{dimensions.height}px</div>
                <div
                    className="td"
                    style={{
                        width: "15%",
                        minWidth: "150px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "15px",
                    }}
                >
                    {item.id === 1 ? (
                        <>
                            <div
                                className="upgrade-btn"
                                onClick={() => onClickData()}
                                style={{ backgroundColor: "#003577", color: "#fff", width: "45px" }}
                            >
                                수정
                            </div>
                            <div
                                className="upgrade-btn"
                                style={{ background: "#fff", color: "#fff", border: "#fff", cursor: "auto", width: "45px" }}
                            >
                            </div>
                        </>
                    ) : (
                        <>
                            <div
                                className="upgrade-btn"
                                onClick={() => onClickData()}
                                style={{ backgroundColor: "#003577", color: "#fff", width: "45px" }}
                            >
                                수정
                            </div>
                            <div className="upgrade-btn" style={{ width: "45px" }} onClick={() => onSubmitDelete()}>
                                삭제
                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    );
}

function JackpotImgModal({ darkname, setJackpotImgModal, clickId, setReload }) {
    const [formData, setFormData] = useState({
        rate: clickId.gold_rate, // 초기 금액 값
        uploadedFile: null, // 업로드된 파일
    });

    const [imagePreview, setImagePreview] = useState(null); // 미리보기 이미지 상태

    // 파일 선택 핸들러
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData((prev) => ({
                ...prev,
                uploadedFile: file,
            }));

            // 미리보기 이미지 설정
            const previewUrl = URL.createObjectURL(file);
            setImagePreview(previewUrl);
        }
    };

    // 입력 값 변경 핸들러
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // 폼 제출 핸들러
    const handleModalSubmit = async () => {
        const formDataToSend = new FormData();
        formDataToSend.append('imgId', clickId.id);
        formDataToSend.append('file', formData.uploadedFile || ""); // 파일이 없으면 빈 문자열
        formDataToSend.append('rate', formData.rate);

        await axios.post(process.env.REACT_APP_API + '/api/setting/jackpot/img-update', formDataToSend, {
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then((response) => {
                let tmp = response.data;
                if (tmp?.code === 1000) {
                    setJackpotImgModal(false);
                    setReload((e) => !e); // 데이터 새로고침
                }
            })
            .catch((error) => {
                console.error("파일 업로드 중 오류 발생:", error);
            });
    };

    return (
        <div className="modal">
            <div className="modal-box">
                <div className="modal-1" style={{ width: '1000px' }}>
                    <div className="modal-1-header">스킨 이미지 수정</div>

                    <div className="modal-body">
                        <div className="modal-flex" style={{ marginBottom: "50px" }}>
                            <div>
                                <div style={{ height: '50px' }}>기존 이미지</div>
                                <div>
                                    <img
                                        src={clickId.url}
                                        style={{ height: '150px' }}
                                        alt="기존 이미지"
                                    />
                                </div>
                            </div>
                            <div>
                                <div style={{ height: '50px' }}>
                                    <div>변경 이미지</div>
                                    <label
                                        htmlFor="modalFile"
                                        className="form-control file_form"
                                        style={{ display: 'block', cursor: 'pointer' }}
                                    >
                                        {formData.uploadedFile
                                            ? formData.uploadedFile.name
                                            : '파일선택'}
                                    </label>
                                    <input
                                        className="file-input"
                                        type="file"
                                        id="modalFile"
                                        name="modalFile"
                                        style={{ display: 'none' }}
                                        accept="image/*"
                                        onChange={handleFileChange}
                                    />
                                </div>
                                <div>
                                    {imagePreview && (
                                        <img
                                            src={imagePreview}
                                            alt="변경 이미지 미리보기"
                                            className="multipreview"
                                            style={{ height: '150px' }}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                        {
                            clickId.id === 1
                                ?
                                <div
                                    className="modal-body-flex"
                                    style={{ width: '600px', margin: '0 auto', marginBottom: '15px' }}
                                >
                                    <div style={{ width: '150px' }}>잭팟 최소 금액</div>
                                    <div style={{ width: '200px' }}>
                                        <input
                                            type="text"
                                            name="rate"
                                            value={formData.rate}
                                            disabled
                                            placeholder="잭팟 최소 금액을 입력하세요"
                                            style={{ width: '100%', color: "gray" }}
                                        />
                                    </div>
                                </div>
                                :
                                <div
                                    className="modal-body-flex"
                                    style={{ width: '600px', margin: '0 auto', marginBottom: '15px' }}
                                >
                                    <div style={{ width: '150px' }}>잭팟 최소 금액</div>
                                    <div style={{ width: '200px' }}>
                                        <input
                                            type="text"
                                            name="rate"
                                            value={formData.rate}
                                            onChange={handleInputChange}
                                            placeholder="잭팟 최소 금액을 입력하세요"
                                            style={{ width: '100%' }}
                                        />
                                    </div>
                                </div>
                        }
                    </div>

                    <div className="modal-btn-box">
                        <div
                            className={`modal-btn ${darkname}`}
                            onClick={handleModalSubmit}
                        >
                            확인
                        </div>
                        <div
                            className={`modal-btn ${darkname}`}
                            onClick={() => setJackpotImgModal(false)}
                        >
                            취소
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default JackpotSetting;